import React from 'react'
import { Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Footer, Header } from '../components'

const AppLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <>
          <Helmet>
            <title>Fizbuz</title>
          </Helmet>
          <Header />
          <div id="default">
            <Component {...props} />
          </div>
          <Footer />
        </>
      )}
    />
  )
}

export default AppLayout
